import React from 'react';
import Header from './components/header';
import ErrorBanner from './components/error_banner';

function AccessDeniedPage() {
    return (
        <> 
            <Header />
            <ErrorBanner />
        </>
    );
  }
  
  export default AccessDeniedPage; 